
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.999 4C22.627 4 28 9.373 28 16.001c0 5.3-3.435 9.794-8.2 11.385-.609.117-.825-.256-.825-.577 0-.394.015-1.688.015-3.292 0-1.119-.384-1.852-.815-2.222 2.673-.297 5.479-1.311 5.479-5.921 0-1.31-.464-2.381-1.233-3.22.124-.304.536-1.524-.119-3.176 0 0-1.006-.323-3.297 1.23a11.528 11.528 0 00-3.004-.404c-1.02.005-2.047.138-3.004.404-2.292-1.553-3.3-1.23-3.3-1.23-.653 1.652-.241 2.872-.118 3.176-.767.839-1.235 1.91-1.235 3.22 0 4.599 2.801 5.628 5.466 5.931-.343.3-.653.829-.762 1.604-.683.307-2.422.837-3.492-.997 0 0-.634-1.152-1.838-1.237 0 0-1.172-.016-.082.729 0 0 .786.369 1.332 1.755 0 0 .704 2.334 4.042 1.609.006 1.001.016 1.756.016 2.041 0 .318-.219.688-.819.578C7.438 25.8 4 21.302 4 16.001 4 9.373 9.373 4 15.999 4z"}})])
          )
        }
      }
    